<div class="statistics-html-container" [innerHTML]="safeHtml">
  No data
</div>
